module.exports = __webpack_public_path__ + "img/Strip-Front-B10-Jd.360b4a3e.png";